import { Box, Center, ModalBody, ModalContent, ModalHeader, Spinner } from "@chakra-ui/react";
import { useDynamicModalContext } from "@umami/components";
import { CoinbaseSDKEvent, TransakSDKEvent } from "@umami/ramp";
import { useEffect, useState } from "react";

import { useWertWidget } from "../../hooks/useWertWidget";
import { ModalBackButton } from "../BackButton";
import { ModalCloseButton } from "../CloseButton";

type BuyProviderModalProps = {
  apiUrl: string;
  openInNewTab?: boolean;
};

export const BuyProviderModal = ({ apiUrl, openInNewTab = false }: BuyProviderModalProps) => {
  const { onClose } = useDynamicModalContext();
  const [isLoading, setIsLoading] = useState(false);

  const isWertWidget = apiUrl.includes("wert.io");

  useWertWidget({
    apiUrl,
    openInNewTab,
    isWertWidget,
    setIsLoading,
    onClose,
  });

  useEffect(() => {
    if (openInNewTab && !isWertWidget) {
      setIsLoading(true);
      window.open(apiUrl, "_blank");
    }
  }, [openInNewTab, apiUrl, isWertWidget]);

  useEffect(() => {
    const handleMessage = (event: MessageEvent) => {
      if (!openInNewTab) {
        if (
          event.origin !== "https://global-stg.transak.com" &&
          event.origin !== "https://global.transak.com"
        ) {
          return;
        }
        const { data } = event;

        if (data.event_id === TransakSDKEvent.TRANSAK_WIDGET_CLOSE) {
          onClose();
        }
      } else {
        // Handle Coinbase events
        const { data } = event;

        if (
          data.event_id === CoinbaseSDKEvent.WIDGET_CLOSE ||
          data.event_id === CoinbaseSDKEvent.TRANSACTION_COMPLETED ||
          data.event_id === CoinbaseSDKEvent.TRANSACTION_FAILED
        ) {
          setIsLoading(false);
          onClose();
        }
      }
    };

    window.addEventListener("message", handleMessage);

    return () => {
      window.removeEventListener("message", handleMessage);
    };
  }, [onClose, openInNewTab]);

  if ((openInNewTab && isLoading) || (isWertWidget && isLoading)) {
    return (
      <ModalContent height={["90%", null, "90%"]} padding="0px">
        <ModalHeader>
          <ModalBackButton aria-label="Back" />
          <ModalCloseButton />
        </ModalHeader>
        <ModalBody marginTop="40px">
          <Center height="100%">
            <Spinner size="xl" />
          </Center>
        </ModalBody>
      </ModalContent>
    );
  }

  return (
    <ModalContent height={["90%", null, "90%"]} padding="0px !important">
      <ModalHeader>
        <ModalBackButton aria-label="Back" />
        <ModalCloseButton />
      </ModalHeader>

      <ModalBody marginTop="40px">
        <Box
          as="iframe"
          width="100%"
          height="100%"
          border="none"
          borderBottomLeftRadius={{ base: "0px", md: "24px" }}
          borderBottomRightRadius={{ base: "0px", md: "24px" }}
          allow="sb;ethereum;clipboard-write;payment;microphone;camera"
          loading="lazy"
          role="presentation"
          src={apiUrl}
          title="Mt Pelerin exchange widget"
        />
      </ModalBody>
    </ModalContent>
  );
};
